<template>
  <div>
    <!-- COMMENTING THIS PAGE FOR NOW-->
    <!-- <div>
    <div class="container" v-if="showOption">
    <div class="row info-card">
      <p>Information Card</p>
    </div>
    <div class="row center">
      <div class="col text-center">
        <button class="btn btn-primary large-btn" @click="showVideoUpload()">Video Upload</button>
      </div>
      <div class="col mr-5 text-center">
        <button class="btn btn-primary large-btn" @click="showBulkUpload()">Bulk Upload</button>
      </div>
    </div>
  </div> -->

    <!-- Single Video Upload Code -->
    <div class="upload-video-container">
      <div class="container video-container row" v-if="videoUpload">
        <div class="col video-player" width="100%">
          <!-- <div @click="backToMenu()">
          <img class="back-btn" src="../assets/icons/arrow-left.svg" height="50px" width="50px"/>
        </div> -->
          <iframe width="100%" height="400" :src="iframeUrl" title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
          <b-alert show small variant="danger"
            class="password-errors alert-ht font-red-16 p-2 mt-1 d-flex justify-content-center" :class="{ hide: hide }">
            {{ errorMessage }}
          </b-alert>
        </div>
        <div class="col video-detail-form" width="50%">
          <div class="form-group">
            <label class="form-label" for="youtube-url">YouTube URL:</label>
            <input type="text" v-model="videoLink" class="form-control" required id="youtube-url"
              placeholder="Enter YouTube URL" />
          </div>
          <div class="form-group">
            <label class="form-label" for="title">Title:</label>
            <input type="text" v-model="title" class="form-control" required id="title" placeholder="Enter Title" />
          </div>
          <div class="row">
            <div class="col-5">
              <label class="form-label" for="start-time">Start Time (Seconds):</label>&nbsp;<span ref="infoOverlay"
                @mouseover="showOverlay" @mouseout="hideOverlay"><img src="../assets/icons/info-circle.svg" /></span>
              <div class="overlay" v-if="showInfoOverlay && index == 0">
                <span class="overlay-text">Start Time: Exercise Start Time in second</span>
              </div>
            </div>
            <div class="col-5">
              <label class="form-label" for="end-time">End Time (Seconds):</label>&nbsp;<span ref="infoOverlay"
                @mouseover="showOverlay" @mouseout="hideOverlay"><img src="../assets/icons/info-circle.svg" /></span>
              <div class="overlay" v-if="showInfoOverlay">
                <span class="overlay-text">End Time: Exercise End Time in second</span>
              </div>
            </div>
          </div>
          <div v-for="(step, index) in steps">
            <div class="row">
              <div class="col-5 form-group">
                <input type="number" v-model="step.start" min="0" required class="form-control" id="start-time"
                  placeholder="Enter Start Time" />
              </div>
              <div class="col-5 form-group">
                <input type="number" v-model="step.end" min="0" required class="form-control" id="end-time"
                  placeholder="Enter End Time" />
              </div>
              <div v-if="index > 0" class="col-2" style="cursor: pointer" @click="removeTimeRow(index)">
                <b-icon-x-square class="pt-1" style="color: #73bc44"></b-icon-x-square>
              </div>
            </div>
          </div>
          <div class="row" style="cursor: pointer" @click="addSteps()">
            <b-icon-plus-square class="pl-3 pb-3" style="width: 38; height: 38; color: #73bc44"></b-icon-plus-square>
          </div>
          <div class="row">
            <div class="col">
              <label class="form-label" for="video-thumbnail">Video Thumbnail</label>
              <b-form-checkbox id="thumbnail-check" v-model="thumbnailCheckStatus" name="checkbox-1" value="youtubeCheck"
                unchecked-value="s3Check" size="lg" label-class="thumbnail-label">
                Youtube Video Thumbnail
              </b-form-checkbox>
            </div>
            <div class="col">
              <b-form-file class="form___file" ref="thumbnail" v-model="thumbnail" :state="Boolean(thumbnail)"
                placeholder="Select File" size="sm" accept="image/*" @input="handleImageChange($event)"></b-form-file>
            </div>
          </div>
          <div class="form-group">
            <b-form-group label="Select Categories" label-for="categories">
              <multiselect v-model="selectedCategories" :options="categoryOptions" placeholder="Select Category"
                label="name" track-by="id" :multiple="true" :close-on-select="false" id="categories"></multiselect>
            </b-form-group>
          </div>
          <div class="form-group">
            <b-form-group label="Select Body Focus" label-for="categories">
              <multiselect v-model="selectedBodyFocus" :options="bodyFocusOptions" placeholder="Select Body Focus"
                label="name" track-by="id" :multiple="true" :close-on-select="false" id="bodyfocus"></multiselect>
            </b-form-group>
          </div>
          <div class="form-group">
            <label class="form-label" for="description">Description:</label>
            <textarea class="form-control" required v-model="description" id="description" rows="4"
              placeholder="Enter Description"></textarea>
          </div>
          <button :disabled="disableUpload" class="btn btn-primary medium-btn" @click="uploadVideo()">
            <span v-if="disableUpload">Uploading...</span>
            <span v-else>Upload</span>
          </button>
        </div>
      </div>

      <!-- Bulk Upload Code-->
      <!-- <div class="container bulk-upload-container" v-if="bulkUpload">
      <div class="drop-area row">
        <div @click="backToMenu()">
          <img class="back-btn" src="../assets/icons/arrow-left.svg" height="50px" width="50px"/>
        </div>
        <div class="col">
          <h6 v-if="message">{{ message }}</h6>
          <div>
            <a href="https://s3.ap-southeast-1.amazonaws.com/www.elitefit.ai/docs/bulk-upload-template.csv">Download Bulk Upload Template</a>
          </div>
          <img src="../assets/icons/upload.svg" height="130px" alt="Upload"/>
          <p>Drag and drop a file here</p>
          <p>or</p>
          <input class="file-input" type="file" id="file-input" multiple>
          <div>
            <button class="btn btn-primary bulk-medium-btn" @click="bulkUpload()">Submit</button>
          </div>
        </div>
      </div>
    </div> -->
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "admin/trainerVideosView"
);
import Swal from "sweetalert2";
import adminApi from "../../module_admin/api.js";
import api from "../api.js";
import EmbedID from "@/utils/youtubeEmbedID.js";
import S3Url from "../../module_admin/s3upload/getSignedURL";
import Multiselect from "vue-multiselect";
import { VIDEO_DATA } from "../../module_admin/utils/constants.js";
import { BIcon } from "bootstrap-vue";
import youtubeApi from "../../module_user/api/youtube";
export default {
  data: function () {
    return {
      uploadThumbnail: true,
      thumbnailCheckStatus: "youtubeCheck",
      intensityOptions: ["Begineer", "Intermediate", "Advance", "Expert"],
      categoryOptions: [],
      bodyFocusOptions: [],
      showOption: false,
      videoUpload: true,
      bulkUpload: false,
      selectedCategories: null,
      selectedBodyFocus: null,
      selectedIntensity: null,
      startTime: null,
      title: null,
      endTime: null,
      videoLink: null,
      description: null,
      embedId: null,
      JsonVideoData: VIDEO_DATA,
      videoIntensity: 3,
      thumbnailChanged: false,
      thumbnail: null,
      createBaselineCheck: true,
      thumbnailTitle: null,
      thumbnailURL: null,
      thumbnailFile: null,
      errorMessage: "",
      hide: true,
      iframeUrl: "",
      selectedFile: "",
      message: false,
      showInfoOverlay: false,
      disableUpload: false,
      userId: null,
      videoLimit: null,
      currentCountOfUploadedVideos: null,
      steps: [{ start: null, end: null, step: "Step 1" }],
      stepNumber: 1,
      stepParts: null,
    };
  },
  components: {
    Multiselect,
    BIcon,
  },
  methods: {
    ...mapActions(["addVideo"]),

    showVideoUpload() {
      this.videoUpload = true;
      this.showOption = false;
      this.bulkUpload = false;
    },
    showBulkUpload() {
      this.bulkUpload = true;
      this.videoUpload = false;
      this.showOption = false;
    },
    backToMenu() {
      this.showOption = true;
      this.bulkUpload = false;
      this.videoUpload = false;
    },
    addSteps() {
      this.steps.push({
        start: null,
        end: null,
        step: "Step " + ++this.stepNumber,
        parts: this.stepParts,
      });
    },
    removeTimeRow(index) {
      this.steps.splice(index, 1);
    },
    validateTimeIntervals(steps) {
      let message = null;

      for (let i = 0; i < steps.length; i++) {
        const { start, end } = steps[i];
        start = Number(start);
        end = Number(end);

        if (!start || !end) {
          message = start ? 'Please Enter End Time' : 'Please Enter Start Time'
          message = !start && !end ? "Please Enter Start and End time" : !start ? "Please Enter Start Time" : !end ? "Please Enter End Time" : null;
          return {
            isValid: false,
            message: message
          };
        }

        if (end <= start) {
          return {
            isValid: false,
            message: 'Start Time needs to be lesser than End Time'
          };
        }

        if (i > 0 && start <= steps[i - 1].end) {
          return {
            isValid: false,
            message: 'Start Time cannot be lesser than previous End Time'
          };
        }
      }

      return {
        isValid: true,
        message: null
      };
    },
    async generateCategoryList() {
      let categories = await api.getAllCategories();
      for (let category of categories) {
        if (
          category.name.toLowerCase().includes("body") ||
          category.name.toLowerCase() == "core"
        ) {
          this.bodyFocusOptions.push({ id: category.id, name: category.name });
        } else {
          this.categoryOptions.push({ id: category.id, name: category.name });
        }
      }
    },
    async checkVideoUploadPossible() {
      this.userId = this.$store.state.userInfo.userId;
      this.videoLimit = this.$store.state.userInfo.corporate.subscription.video_limit;
      let countResponse = await api.getCurrentUploadCount(this.userId);
      this.currentCountOfUploadedVideos = parseInt(countResponse[0].count);
      if (this.currentCountOfUploadedVideos >= this.videoLimit) {
        Swal.fire({
          title: "Reached Limit",
          text:
            "Maximum upload limit of 2 videos reached during your free trial period",
          icon: "warning",
          confirmButtonText: "OK",
        })
          .then((result) => {
            if (result.isConfirmed) {
              this.$router.push("/management/video/list");
            }
          })
          .finally((result) => {
            this.$router.push("/management/video/list");
          });
      }
    },
    async uploadVideo() {
      this.hide = true;
      this.userId = this.$store.state.userInfo.userId;
      let selectedCategory = [];
      if (this.selectedCategories && this.selectedBodyFocus) {
        let selectedItems = this.selectedCategories.concat(
          this.selectedBodyFocus
        );
        for (let item of selectedItems) {
          selectedCategory.push(item.id);
        }
      } else if (this.selectedCategories) {
        let selectedItems = this.selectedCategories;
        for (let item of selectedItems) {
          selectedCategory.push(item.id);
        }
      } else if (this.selectedBodyFocus) {
        let selectedItems = this.selectedBodyFocus;
        for (let item of selectedItems) {
          selectedCategory.push(item.id);
        }
      }

      this.errorMessage = "";
      this.hide = false;

      if (!this.videoLink) {
        this.errorMessage = "Please Enter YouTube Video Link";
        this.$refs.embedId.focus();
      } else if (
        this.thumbnailCheckStatus == "s3Check" &&
        !this.thumbnailTitle
      ) {
        this.errorMessage = "Please Select Thumbnail Image";
        this.$refs.thumbnailTitle.focus();
      } else if (!this.title) {
        this.errorMessage = "Please Enter Video Title";
        this.$refs.title.focus();
      } else if (!this.description) {
        this.errorMessage = "Please Enter Video Description";
        this.$refs.description.focus();
      } else if (!this.steps[0].start) {
        this.errorMessage = "Please Enter Start Time";
      } else if (!this.steps[0].end) {
        this.errorMessage = "Please Enter End Time";
      } else if (!this.validateTimeIntervals(this.steps).isValid) { 
        this.errorMessage = this.validateTimeIntervals(this.steps).message;
        console.log("fcef", this.errorMessage, this.steps);
      } else {
        this.disableAddButton = true;
        this.hide = true;

        this.embedId = EmbedID.getEmbedID(this.videoLink);
        this.JsonVideoData.start = parseInt(this.steps[0].start);
        this.JsonVideoData.end = parseInt(this.steps[this.steps.length-1].end);
        this.JsonVideoData.steps = this.steps;
        if (this.thumbnailCheckStatus == "s3Check" && this.thumbnailChanged) {
          await this.getS3Cred();
          let s3Cred = this.$store.state.admin.trainerVideosView.s3Cred;
          //upload thumbnail to s3
          let thumbResponse = await S3Url.getS3Url(
            s3Cred,
            this.thumbnailFile,
            this.thumbnail,
            "thumbnails"
          );
          this.thumbnailURL = thumbResponse.Location;
          this.thumbnailChanged = false;
        }

        if (this.thumbnailCheckStatus == "youtubeCheck") {
          this.thumbnailURL =
            "https://img.youtube.com/vi/" + this.embedId + "/sddefault.jpg";
        }

        this.disableUpload = true;

        const videoDuration = await youtubeApi.getVideoDuration(this.embedId);

        if (videoDuration.error) {
          this.errorMessage = "Please enter a valid YouTube video URL";
          this.hide = false;
          this.disableUpload = false;
        }

        let videoData = {
          userId: this.userId,
          embedId: this.embedId,
          title: this.title,
          duration: videoDuration.duration,
          description: this.description,
          categories: selectedCategory,
          thumbnail: this.thumbnailURL,
          data: this.JsonVideoData,
          intensity: this.videoIntensity,
          createBaseline: this.createBaselineCheck,
          Date: new Date(),
        };

        try {
          this.hide = true;
          let response = await api.addVideo(videoData);
          if (response.code == 501) {
            const baselineMessage = {
              videoId: response.data.video.id,
              failedStep: "Failed to Start Baseline Process. Please check!!",
            };
            await api.sendBaselineStatus(baselineMessage);
          }
          Swal.fire({
            title: "Video Uploaded Successfully",
            text:
              "Your video is being trained by our AI and it will be ready in a few hours. We will send an email notification when the video is ready.",
            icon: "success",
            confirmButtonText: "OK",
          });
          this.$router.push("/management/video/list");
          this.disableUpload = false;
        } catch (error) {
          console.log(error);
          this.hide = false;
          this.errorMessage = "Failed to upload Video. Please try again!!";
          this.disableUpload = false;
        }
        this.edit = false;
      }
    },
    handleImageChange(e) {
      this.thumbnailChanged = true;
      this.thumbnailTitle = e.name;
      this.thumbnailFile = e;
      const reader = new FileReader();

      reader.onload = (e) => {
        this.thumbnail = e.target.result;
        this.thumbnailSrc =
          "data:image/jpeg;base64," +
          btoa(
            new Uint8Array(this.thumbnail).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      };
      reader.readAsArrayBuffer(e);
    },

    showOverlay() {
      this.showInfoOverlay = true;
    },

    hideOverlay() {
      this.showInfoOverlay = false;
    },
    /* Single Video Upload code End */

    /* Bulk Upload Code Start*/
    onFileSeleted(event) {
      this.message = false;
      this.selectedFile = event.target.files;
    },
    async onBulkUpload() {
      this.message = false;
      const data = new FormData();
      const csvFile = document.querySelector("#file");
      data.append("file", csvFile.files[0]);
      try {
        this.message = "Bulk Upload Submitted";
        let response = await adminApi.bulkUploadVideos(data);
        this.isDisabled = true;
        if (response.status == 200) {
          this.message = response.message;
        }
        this.isDisabled = false;
      } catch (error) {
        this.message = "Bulk Upload Failed";
      }
    },
    /* Bulk Upload Code End*/
  },
  mounted() {
    this.stepParts = this.JsonVideoData.steps[0].parts;
    this.steps[0].parts = this.stepParts;
    this.checkVideoUploadPossible();
    this.generateCategoryList();
  },
  watch: {
    videoLink: {
      handler() {
        this.embedId = EmbedID.getEmbedID(this.videoLink);
        this.iframeUrl = `https://www.youtube.com/embed/${this.embedId}`;
      },
    },
    selectedCategories: {
      handler() {
        if (this.selectedCategories.length > 2) {
          this.hide = false;
          this.errorMessage = "Please select only 2 Categories";
          this.selectedCategories.pop();
        }
      },
    },
    selectedBodyFocus: {
      handler() {
        if (this.selectedBodyFocus.length > 1) {
          this.hide = false;
          this.errorMessage = "Please select only 1 Body Focus";
          this.selectedBodyFocus.pop();
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.form-control {
  padding: 5px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.info-card {
  margin: auto;
  height: 50%;
  width: 50%;
  background-color: #f1eded;
  padding: 30px;
}

.file-input {
  margin-left: 120px;
}

.medium-btn {
  height: 60px;
  width: 100%;
  font-weight: bold;
  font-size: 25px;
}

.bulk-medium-btn {
  height: 60px;
  width: 40%;
  font-weight: bold;
  font-size: 25px;
  margin-top: 30px;
}

.large-btn {
  height: 80px;
  width: 200px;
  font-size: 25px;
}

.upload-video-container {
  display: flex;
  background-color: #f1eded;
  margin: 0;
  width: 100%;
  height: 90vh;
}

.video-container {
  width: 200%;
  background-color: white;
  box-shadow: 0 3px 6px rgba(135, 222, 108, 0.3);
  margin: auto;
  padding: 30px 20px;
  border-radius: 18px;
}

.video-detail-form .video-player {
  flex: 1;
}

.bulk-upload-container {
  background-color: #f1eded;
}

.drop-area {
  font-size: larger;
  font-family: "Poppins";
  font-size: 22px;
  width: 100%;
  height: 50vh;
  padding: 30px;
  text-align: center;
  margin: auto;
  margin-top: 10%;
  border-radius: 18px;
  background-color: white;
  box-shadow: 0 3px 6px rgba(135, 222, 108, 0.3);
}

.password-errors {
  ul {
    list-style-type: none;
    text-align: center;
    margin-left: 1rem;
    width: 100%;
    font-size: 80%;
    color: #dc3545;
  }
}

.password-errors.hide {
  display: none !important;
}

.back-btn {
  margin-top: -24px;
  margin-left: -30px;
}

.back-btn:hover {
  background-color: #f1eded;
  border-radius: 18px;
}

.overlay {
  position: absolute;
  top: 0;
  right: 0;
  left: 44%;
  padding: 5px;
  background-color: #f2f2f2;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.overlay-text {
  color: #333;
  font-size: 14px;
}

::v-deep .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e") !important;
}

::v-deep .custom-control-input:checked ~ .custom-control-label::before{
  background-color: #28c76f !important;
}
</style>
